module.exports = __webpack_public_path__ + "media/images/pen_limegreen-166ee3ab.png";